module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.7799/images/logos/loom-logo.png"